import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import type {
  EstadoPanelCliente,
  Cotizacion,
  CotizacionContratada,
  Empresa,
  Solicitud,
  Calificaciones,
  Mensaje,
} from './types';

Vue.use(Vuex);

const estadoInicial: EstadoPanelCliente = {
  calificaciones: { data: [] },
  cotizacion_contratada: null,
  cotizacion: { empresa: {} as Empresa } as Cotizacion & { empresa: Empresa },
  enProgreso: false,
  error: false,
  errorGlobal: null,
  id_mm: null,
  mensajes: [],
  solicitud: {},
  token: null,
  uriApiClient: null,
};

export default new Vuex.Store<EstadoPanelCliente>({
  state: estadoInicial,
  getters: {
    getField,
  },
  mutations: {
    updateField,

    SET_CONTEXTO_CLIENTE(estado, payload: { id_mm: string; token: string }) {
      estado.id_mm = payload.id_mm;
      estado.token = payload.token;
      estado.uriApiClient = `graphql?id_mm=${payload.id_mm}&t=${payload.token}`;
    },

    SET_EN_PROGRESO(estado, valor: boolean) {
      estado.enProgreso = valor;
    },

    SET_ERROR(estado, valor: boolean) {
      estado.error = valor;
    },

    SET_ERROR_GLOBAL(estado, mensaje: string | null) {
      estado.errorGlobal = mensaje;
    },

    SET_SOLICITUD(estado, solicitud: Partial<Solicitud>) {
      estado.solicitud = solicitud;
    },

    FUSIONAR_SOLICITUD(estado, parcial: Partial<Solicitud>) {
      estado.solicitud = { ...estado.solicitud, ...parcial };
    },

    SET_COTIZACION(estado, cotizacion: Cotizacion & { empresa: Empresa }) {
      estado.cotizacion = cotizacion;
    },

    SET_COTIZACION_CONTRATADA(estado, contrato: CotizacionContratada | null) {
      estado.cotizacion_contratada = contrato;
    },

    SET_CALIFICACIONES(estado, calificaciones: Calificaciones) {
      estado.calificaciones = calificaciones;
    },

    SET_MENSAJES(estado, mensajes: Mensaje[]) {
      estado.mensajes = mensajes;
    },

    AGREGAR_MENSAJE(estado, mensaje: Mensaje) {
      estado.mensajes = [...estado.mensajes, mensaje];
    },
  },
});
